<template>
  <v-layout column class="pagemargin page">
    <!--TITLE -->
    <v-layout row wrap class="noprint">
      <v-flex md12>
        <v-toolbar color="secondary">
          <v-toolbar-title class="font-weight-thin white--text">
            Print Comparison Report between
            <strong>{{gName}}</strong> and
            <strong>{{secondGName}}</strong>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-icon @click="printPage" dark right large class="icons8-pdf"></v-icon>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <div id="printMe">
      <div style="page-break-after: always; max-width: 700px !important;">
        <!-- LOGO -->
        <p align="center">
          <img
            style="max-width: 40%;"
            :src="require('@/assets/colour-logo-transparent-bg.png')"
            class="printonly"
          />
        </p>
        <!--FIXTURE INFO-->
        <h4
          style="margin-top: 15%;"
          class="printonly"
        >Comparison between {{gName}} and {{secondGName}}</h4>
        <div class="printContainer printonly" style="page-break-after: always;">
          <!-- FIRST GAME -->
          <div id="firstContainer" style="margin-top: 4%;">
            <table border="1">
              <tr>
                <td class="more-info-title primary--text">{{gName}}</td>
                <td></td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Competition:</td>
                <td>{{game.competition}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Fixture:</td>
                <td>{{game.gameName}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Result:</td>
                <td>{{game.result}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Venue:</td>
                <td>{{game.venue}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Attendence:</td>
                <td>{{game.attendence}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Broadcast Channel:</td>
                <td>{{game.tvChannel}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Viewing Figures:</td>
                <td>{{game.viewing}}</td>
              </tr>
            </table>
          </div>
          <!-- SECOND GAME -->
          <div id="secondContainer" style="margin-top: 4%;">
            <table border="1">
              <tr>
                <td class="more-info-title primary--text">{{secondGName}}</td>
                <td></td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Competition:</td>
                <td>{{secondGame.competition}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Fixture:</td>
                <td>{{secondGame.gameName}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Result:</td>
                <td>{{secondGame.result}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Venue:</td>
                <td>{{secondGame.venue}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Attendence:</td>
                <td>{{secondGame.attendence}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Broadcast Channel:</td>
                <td>{{secondGame.tvChannel}}</td>
              </tr>
              <tr>
                <td class="more-info-title primary--text">Viewing Figures:</td>
                <td>{{secondGame.viewing}}</td>
              </tr>
            </table>
          </div>
          <div id="clear"></div>
        </div>
      </div>
      <!-- CHARTS-->
      <div class="printContainer" style="page-break-after: always;">
        <div id="firstContainer" style="max-width: 370px !important;">
          <h3 class="noprint">Top 5 Sponsors by Air Time - {{gName}}</h3>
          <h4
            class="printonly"
            style="margin-top: 3% !important"
          >Top 5 Sponsors by Air Time - {{gName}}</h4>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SponsorsByAirTime />
        </div>
        <div id="secondContainer" style="max-width: 370px !important;">
          <h3 class="noprint">Top 5 Sponsors by Air Time - {{secondGName}}</h3>
          <h4
            class="printonly"
            style="margin-top: 3% !important"
          >Top 5 Sponsors by Air Time - {{secondGName}}</h4>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondSponsorsByAirTime />
        </div>
        <div id="clear"></div>
      </div>
      <br />
      <div class="printContainer" style="page-break-after: always;">
        <div id="firstContainer" style="max-width: 370px !important;">
          <h3 class="noprint">Top 5 Locations by Air Time - {{gName}}</h3>
          <h4
            class="printonly"
            style="margin-top: 3% !important"
          >Top 5 Locations by Air Time - {{gName}}</h4>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <LocationsByAirTime />
        </div>
        <div id="secondContainer" style="max-width: 370px !important;">
          <h3 class="noprint">Top 5 Locations by Air Time - {{secondGName}}</h3>
          <h4
            class="printonly"
            style="margin-top: 3% !important"
          >Top 5 Locations by Air Time - {{secondGName}}</h4>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondLocationsByAirTime />
        </div>
        <div id="clear"></div>
      </div>
      <br />
      <div class="printContainer" style="page-break-after: always;">
        <div id="firstContainer" style="max-width: 370px !important;">
          <h3 class="noprint">Top 5 by Ad Frequency - {{gName}}</h3>
          <h4 class="printonly" style="margin-top: 3% !important">Top 5 by Ad Frequency - {{gName}}</h4>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SponsorsByAdFrequency />
        </div>
        <div id="secondContainer" style="max-width: 370px !important;">
          <h3 class="noprint">Top 5 by Ad Frequency - {{secondGName}}</h3>
          <h4
            class="printonly"
            style="margin-top: 3% !important"
          >Top 5 by Ad Frequency - {{secondGName}}</h4>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondSponsorsByAdFrequency />
        </div>
        <div id="clear"></div>
      </div>
      <br />
      <div class="printContainer">
        <div id="firstContainer" style="max-width: 370px !important;">
          <h3 class="noprint">Top 5 Sponsors by Dwell Time - {{gName}}</h3>
          <h4
            class="printonly"
            style="margin-top: 3% !important"
          >Top 5 Sponsors by Dwell Time - {{gName}}</h4>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SponsorsByDwellTime />
        </div>
        <div id="secondContainer" style="max-width: 370px !important;">
          <h3 class="noprint">Top 5 Sponsors by Dwell Time - {{secondGName}}</h3>
          <h4
            class="printonly"
            style="margin-top: 3% !important"
          >Top 5 Sponsors by Dwell Time - {{secondGName}}</h4>
          <v-divider style="margin: 0px 20px 0px 20px !important" />
          <SecondSponsorsByDwellTime />
        </div>
        <div id="clear"></div>
      </div>
      <br />
    </div>
    <!--/CHARTS-->
    <div style="height: 50px !important" class="noprint"></div>
    <!-- bottom navigation -->
    <v-bottom-nav app :active.sync="bottomNav" :value="true" fixed color="white" class="noprint">
      <v-btn color="primary" value="recent" flat v-on:click="backToGames()">
        <span color="primary">Back</span>
        <v-icon color="primary">icons8-sort-left</v-icon>
      </v-btn>
      <v-btn color="primary" value="home" flat v-on:click="backToGames()">
        <span>Games</span>
        <v-icon>icons8-stadium</v-icon>
      </v-btn>
    </v-bottom-nav>
  </v-layout>
</template>

<script>
import SponsorsByAirTime from "@/components/charts/SponsorsByAirTime.vue";
import LocationsByAirTime from "@/components/charts/LocationsByAirTime.vue";
import SponsorsByAdFrequency from "@/components/charts/SponsorsByAdFrequency.vue";
import SponsorsByDwellTime from "@/components/charts/SponsorsByDwellTime.vue";

import SecondSponsorsByAirTime from "@/components/comparisonCharts/SecondSponsorsByAirTime.vue";
import SecondLocationsByAirTime from "@/components/comparisonCharts/SecondLocationsByAirTime.vue";
import SecondSponsorsByAdFrequency from "@/components/comparisonCharts/SecondSponsorsByAdFrequency.vue";
import SecondSponsorsByDwellTime from "@/components/comparisonCharts/SecondSponsorsByDwellTime.vue";

import Vue from "vue";
import { mapState } from "vuex";

export default {
  name: "ComparisonReportView",
  components: {
    SponsorsByAirTime,
    LocationsByAirTime,
    SponsorsByAdFrequency,
    SponsorsByDwellTime,
    SecondSponsorsByAirTime,
    SecondLocationsByAirTime,
    SecondSponsorsByAdFrequency,
    SecondSponsorsByDwellTime
  },
  data() {
    return {
      active: null,
      bottomNav: "home",
      games: [],
      portalList: [],
      selected: "",
      secondselected: "",
      output: null,
      game: [],
      secondGame: []
    };
  },
  computed: {
    ...mapState({
      portal: state => state.portal,
      Portals: state => state.Admin.Portals,
      Documents: state => state.Admin.Documents,
      gameID: state => state.game.gameID,
      secondGameID: state => state.game.secondGameID,
      gName: state => state.report.gameName,
      secondGName: state => state.report.secondGameName,
      gID: state => state.report.gameID,
      secondGID: state => state.report.secondGameID,
      DocByID: state => state.Admin.DocByID,
      SecondDocByID: state => state.Admin.SecondDocByID
    })
  },
  watch: {
    portal: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    Portals: {
      handler: function() {
        this.portalList = this.Portals;
      },
      deep: true
    },
    Documents: {
      handler: function() {
        this.games = this.Documents;
      },
      deep: true
    },
    DocumentResult: {
      handler: function() {
        this.readGames();
      },
      deep: true
    },
    // fixture info for the first game
    DocByID: {
      handler: function() {
        this.game = this.DocByID;
      },
      deep: true
    },
    DocResultByID: {
      handler: function() {
        this.readOneGame();
      },
      deep: true
    },
    // fixture info for the second game
    SecondDocByID: {
      handler: function() {
        this.secondGame = this.SecondDocByID;
      },
      deep: true
    },
    SecondDocResultByID: {
      handler: function() {
        this.readSecondGame();
      },
      deep: true
    },
    loading(val) {
      if (!val) return;
      setTimeout(() => (this.loading = false), 2000);
    }
  },
  methods: {
    printPage() {
      window.print();
    },
    initializePage() {
      // first game
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.gID,
        "Admin/setDocByID"
      ]);
      var i = 0;
      var gameName = "";
      for (i = 0; i < this.Documents.length; i++) {
        if (this.gID === this.Documents[i].id) {
          gameName = this.Documents[i].gameName;
          this.$store.commit("report/setValue", ["gameName", gameName]);
        }
      }
      // second game
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.secondGID,
        "Admin/setSecondDocByID"
      ]);
      var i = 0;
      var secondGName = "";
      for (i = 0; i < this.Documents.length; i++) {
        if (this.secondGID === this.Documents[i].id) {
          secondGName = this.Documents[i].gameName;
          this.$store.commit("report/setValue", [
            "secondGameName",
            secondGName
          ]);
        }
      }
    },
    readGames() {
      this.$store.dispatch("Admin/readDocuments", [
        "games",
        this.portal.active.id,
        "Admin/setDocuments"
      ]);
    },
    readOneGame() {
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.gID,
        "Admin/setDocByID"
      ]);
    },
    readSecondGame() {
      this.$store.dispatch("Admin/readDocumentByID", [
        "games",
        this.secondGID,
        "Admin/setSecondDocByID"
      ]);
    },
    backToGames() {
      this.$router.push("/comparisonreport");
    },
    redirectToPrint() {
      // this.$router.push("/printcomparison");
      this.$htmlToPaper("printMe", () => {
        // console.log("Printing done or got cancelled!");
      });
    },
    printFirst() {
      // this.$router.push("/printcomparison");
      this.$htmlToPaper("first-report", () => {
        // console.log("Printing done or got cancelled!");
      });
    },
    printSecond() {
      this.$htmlToPaper("second-report", () => {
        // console.log("Printing done or got cancelled!");
      });
    }
  },
  mounted() {
    this.$emit("navOpen", false);
    this.readGames();
    this.initializePage();
    this.$store.dispatch("portal/readLookups", [
      "lookups",
      this.portal.active.id,
      "portal/setLookups",
      "portal/setLookupsResult"
    ]);
  }
};
</script>

<style>
.select-container {
  position: relative;
  z-index: 2;
  margin-top: 10%;
}

.comparison-title {
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.02em;
}

.report-titles {
  margin-top: 30px !important;
}

.printonly {
  display: none;
}

.printContainer {
  width: 100%;
  margin: auto;
  text-align: center;
  position: relative;
}
#firstContainer {
  width: 49%;
  display: inline-block;
  margin-right: 1%;
}
#secondContainer {
  width: 49%;
  display: inline-block;
}
#clear {
  clear: both;
}

@media print {
  h3 {
    page-break-before: auto;
    font-size: 20px !important;
  }
  .newpage {
    color: pink !important;
  }
  .printonly {
    display: block;
  }
}
</style>

